import { SafeAnyType } from 'src/utils/safeAny';

type KeysType = 'checkExpiredCampaignsModal' | 'accountOrganizerEventRegistrationsQrCamera';

export const setLocalStorage = (key: KeysType, value: SafeAnyType) => localStorage.setItem(key, value);
export const getLocalStorage = (key: KeysType) => localStorage.getItem(key);
export const clearLocalStorage = (key: KeysType) => localStorage.removeItem(key);

export const getAndClearLocalStorage = (key: KeysType) => {
  const value = getLocalStorage(key);
  clearLocalStorage(key);

  return value;
};
